import type { PropifyEntity } from '@/domain/base';

export enum LeadStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface Lead extends PropifyEntity {
  source: string;
  status: LeadStatus;
  firstName?: string;
  lastName?: string;
  phone: string;
  email: string;
  message?: string;
  propertyId: number;
  floorplanId: number;
  unitId: number;
  personId: number;
}
